
  export const initialProjectState = {
  "brandingData": {
    "relationTo": "branding",
    "name": "Branding - Trinity Park",
    "colours": {
      "primary": "#024439",
      "secondary": "#B4C7C4",
      "accent": "#FDFADD"
    },
    "fonts": {
      "primaryFont": {
        "id": "6718c77b32db23ad58bd7600",
        "filename": "RoxboroughCF-Regular.otf",
        "mimeType": "font/otf",
        "filesize": 67552,
        "createdAt": "2024-10-23T09:52:59.810Z",
        "updatedAt": "2024-10-23T09:52:59.881Z",
        "publicURL": "/payload/projectFontMedia/RoxboroughCF-Regular.otf",
        "thumbnailURL": null,
        "url": "https://luna.vmistudio.com/api/projectFontMedia/file/RoxboroughCF-Regular.otf"
      },
      "secondaryFont": {
        "id": "6718c78532db23ad58bd7630",
        "filename": "RoxboroughCF-RegularItalic.otf",
        "mimeType": "font/otf",
        "filesize": 72824,
        "createdAt": "2024-10-23T09:53:09.251Z",
        "updatedAt": "2024-10-23T09:53:09.304Z",
        "publicURL": "/payload/projectFontMedia/RoxboroughCF-RegularItalic.otf",
        "thumbnailURL": null,
        "url": "https://luna.vmistudio.com/api/projectFontMedia/file/RoxboroughCF-RegularItalic.otf"
      }
    },
    "logos": {
      "lightColourLogo": {
        "id": "67346ab3a0480a03f68a0ce7",
        "publicURL": "/payload/projectLogoMedia/logo-cream.svg",
        "filename": "logo-cream.svg",
        "mimeType": "image/svg+xml",
        "filesize": 3903,
        "width": 828,
        "height": 708,
        "createdAt": "2024-11-13T09:00:35.478Z",
        "updatedAt": "2024-11-13T09:00:35.478Z",
        "url": "https://luna.vmistudio.com/api/projectLogoMedia/file/logo-cream.svg",
        "thumbnailURL": null
      },
      "darkColourLogo": {
        "id": "67346abda0480a03f68a0d22",
        "publicURL": "/payload/projectLogoMedia/logo-green.svg",
        "filename": "logo-green.svg",
        "mimeType": "image/svg+xml",
        "filesize": 3903,
        "width": 828,
        "height": 708,
        "createdAt": "2024-11-13T09:00:45.045Z",
        "updatedAt": "2024-11-13T09:00:45.045Z",
        "url": "https://luna.vmistudio.com/api/projectLogoMedia/file/logo-green.svg",
        "thumbnailURL": null
      }
    },
    "bgImage": "6718d3e232db23ad58bdbaea"
  },
  "navigationData": {
    "relationTo": "navigation",
    "name": "Navigation - Trinity Park",
    "menuItems": [
      {
        "include": "true",
        "navLabel": "Intro",
        "pageType": "info1",
        "id": "6718c699b5c2c70026898852"
      },
      {
        "include": "true",
        "navLabel": "Residences",
        "pageType": "residences",
        "id": "6718c699b5c2c70026898849"
      },
      {
        "include": "true",
        "navLabel": "Map",
        "pageType": "map",
        "id": "6718c699b5c2c7002689884a"
      },
      {
        "include": "true",
        "navLabel": "Gallery",
        "pageType": "gallery",
        "id": "6718c699b5c2c7002689884b"
      },
      {
        "include": "true",
        "navLabel": "Favourites",
        "pageType": "favourites",
        "id": "6718c699b5c2c7002689884c"
      },
      {
        "include": "false",
        "navLabel": "Explorer",
        "pageType": "explorer",
        "id": "6718c699b5c2c7002689884d"
      },
      {
        "include": "false",
        "navLabel": "Development",
        "pageType": "development",
        "id": "6718c699b5c2c7002689884e"
      },
      {
        "include": "false",
        "navLabel": "Orbit",
        "pageType": "orbits",
        "id": "6718c699b5c2c7002689884f"
      },
      {
        "include": "false",
        "navLabel": "Shared Ownership",
        "pageType": "sharedOwnership",
        "id": "6718c699b5c2c70026898850"
      },
      {
        "include": "false",
        "navLabel": "About Page",
        "pageType": "about",
        "id": "6718c699b5c2c70026898851"
      }
    ],
    "layout": "sidebar",
    "logo": "lightColourLogo",
    "logoWidth": 8,
    "fontColour": "white",
    "bgColor": "primary",
    "burgerBackgroundColour": "secondary",
    "burgerBorderColour": "accent",
    "burgerWidth": 3.5,
    "shapeColour": "secondary"
  },
  "explorerData": null,
  "sharedOwnershipData": {
    "relationTo": "sharedOwnership",
    "name": "Shared Ownership - Trinity Park",
    "feature": "sharedOwnership"
  },
  "aboutData": {
    "relationTo": "about",
    "name": "About - Trinity Park",
    "feature": "about",
    "sections": []
  },
  "info1Data": {
    "relationTo": "info1",
    "name": "Info1 - Trinity Park",
    "feature": "info1",
    "style": "full",
    "sections": [
      {
        "title": "INTRO",
        "block": [
          {
            "headline": "Park River City",
            "body": "Discover Trinity Park, where the vibrancy of city life meets with peaceful escapism.",
            "img": {
              "id": "6718cbbf32db23ad58bd83f0",
              "filename": "463_TRINITY_AERIAL_03.webp",
              "mimeType": "image/webp",
              "filesize": 582746,
              "width": 1949,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-10-23T10:11:11.676Z",
              "updatedAt": "2024-11-12T11:33:36.036Z",
              "publicURL": "/payload/galleryMedia/463_TRINITY_AERIAL_03.webp",
              "thumbnailURL": null,
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_AERIAL_03.webp"
            },
            "id": "6718c7f5b5c2c70026898c45"
          },
          {
            "headline": "Live with the seasons",
            "body": "A unique community of new 1, 2 and 3 bedroom apartments and 3 and 4 bedroom houses in Woolwich, one of London’s oldest maritime districts. ",
            "img": {
              "id": "6718caf332db23ad58bd806e",
              "filename": "463_TRINITY_APARTMENT_STREETSCAPE.webp",
              "mimeType": "image/webp",
              "filesize": 475480,
              "width": 1896,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-10-23T10:07:47.673Z",
              "updatedAt": "2024-11-12T12:01:53.514Z",
              "publicURL": "/payload/galleryMedia/463_TRINITY_APARTMENT_STREETSCAPE.webp",
              "thumbnailURL": null,
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_APARTMENT_STREETSCAPE.webp"
            },
            "id": "6718c801b5c2c70026898c46"
          },
          {
            "headline": "London living starts here",
            "body": "The buzz of Central London just a stone’s throw away, and a peaceful sanctuary\nto escape to at the end of a busy day.",
            "img": {
              "id": "6718fe29424045c417b523bd",
              "filename": "463_TRINITY_APARTMENT_HERO.webp",
              "mimeType": "image/webp",
              "filesize": 336818,
              "width": 1406,
              "height": 1005,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-10-23T13:46:17.094Z",
              "updatedAt": "2025-01-23T16:50:40.695Z",
              "publicURL": "/payload/galleryMedia/463_TRINITY_APARTMENT_HERO.webp",
              "thumbnailURL": null,
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_APARTMENT_HERO.webp"
            },
            "id": "6718c803b5c2c70026898c47"
          },
          {
            "headline": "Your  big city  gateway",
            "body": "Offering the perfect fusion of excitement and escapism, it’s ideal for first-time buyers, growing families, and anyone in between.",
            "img": {
              "id": "67334454a0480a03f689ec24",
              "publicURL": "/payload/galleryMedia/463_TRINITY_MEWS_NO_TREE.webp",
              "filename": "463_TRINITY_MEWS_NO_TREE.webp",
              "mimeType": "image/webp",
              "filesize": 571396,
              "width": 1875,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-11-12T12:04:36.797Z",
              "updatedAt": "2024-11-12T12:04:36.797Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_MEWS_NO_TREE.webp",
              "thumbnailURL": null
            },
            "id": "6718c813b5c2c70026898c48"
          },
          {
            "headline": "An oasis of calm and belonging",
            "body": "The light and dark warm-coloured brick, white stone and large bronze colour windows perfectly complement the soft tones of the surrounding parklands.",
            "img": {
              "id": "67334474a0480a03f689ec55",
              "publicURL": "/payload/galleryMedia/463_TRINITY_TOWNHOUSE_HERO.webp",
              "filename": "463_TRINITY_TOWNHOUSE_HERO.webp",
              "mimeType": "image/webp",
              "filesize": 245504,
              "width": 1672,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-11-12T12:05:08.777Z",
              "updatedAt": "2024-11-12T12:05:08.777Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_TOWNHOUSE_HERO.webp",
              "thumbnailURL": null
            },
            "id": "6718c822b5c2c70026898c49"
          },
          {
            "headline": "Breathe easy,  move freely,  grow happy",
            "body": "Interiors designed with care and you in mind.",
            "img": {
              "id": "67334499a0480a03f689ec83",
              "publicURL": "/payload/galleryMedia/463_TRINITY_APARTMENT_LIVING_ROOM.webp",
              "filename": "463_TRINITY_APARTMENT_LIVING_ROOM.webp",
              "mimeType": "image/webp",
              "filesize": 257402,
              "width": 2491,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-11-12T12:05:45.731Z",
              "updatedAt": "2024-11-12T12:05:45.731Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_APARTMENT_LIVING_ROOM.webp",
              "thumbnailURL": null
            },
            "id": "6718c825b5c2c70026898c4a"
          },
          {
            "headline": "Where  city life  meets nature's embrace",
            "body": "Trinity Park is the perfect haven – a place to recharge your batteries and reconnect to what’s important.",
            "img": {
              "id": "673344caa0480a03f689ecc1",
              "publicURL": "/payload/galleryMedia/463_TRINITY_APARTMENT_KITCHEN.webp",
              "filename": "463_TRINITY_APARTMENT_KITCHEN.webp",
              "mimeType": "image/webp",
              "filesize": 244522,
              "width": 2500,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-11-12T12:06:34.162Z",
              "updatedAt": "2024-11-12T12:06:34.162Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_APARTMENT_KITCHEN.webp",
              "thumbnailURL": null
            },
            "id": "6718c871b5c2c70026898c4b"
          },
          {
            "headline": "Let the light flood in",
            "body": "Let the light gently transform each space through carefully designed features.",
            "img": {
              "id": "673344eda0480a03f689ecf1",
              "publicURL": "/payload/galleryMedia/463_TRINITY_TOWNHOUSE_BEDROOM.webp",
              "filename": "463_TRINITY_TOWNHOUSE_BEDROOM.webp",
              "mimeType": "image/webp",
              "filesize": 192360,
              "width": 2249,
              "height": 1406,
              "focalX": 50,
              "focalY": 50,
              "createdAt": "2024-11-12T12:07:09.040Z",
              "updatedAt": "2024-11-12T12:07:09.040Z",
              "url": "https://luna.vmistudio.com/api/galleryMedia/file/463_TRINITY_TOWNHOUSE_BEDROOM.webp",
              "thumbnailURL": null
            },
            "id": "6718c879b5c2c70026898c4c"
          }
        ],
        "id": "6718c7ddb5c2c70026898c44"
      }
    ]
  },
  "developmentData": {
    "relationTo": "development",
    "name": "Development - Trinity Park",
    "feature": "development"
  },
  "favouritesData": {
    "relationTo": "favourites",
    "name": "Favourites - Trinity Park",
    "feature": "favourites",
    "shareType": {
      "shareAppURL": "https://trinity-pwa.vercel.app",
      "hiddenProjectId": {
        "id": "6718c69932db23ad58bd7386",
        "name": "Trinity Park",
        "organisation": "6718c68d32db23ad58bd731b",
        "published": true,
        "createdAt": "2024-10-23T09:49:13.832Z",
        "updatedAt": "2024-10-23T10:59:33.767Z",
        "pages": [
          {
            "relationTo": "branding",
            "value": "6718c69932db23ad58bd7396"
          },
          {
            "relationTo": "navigation",
            "value": "6718c69932db23ad58bd7397"
          },
          {
            "relationTo": "splash",
            "value": "6718c69932db23ad58bd7392"
          },
          {
            "relationTo": "residences",
            "value": "6718c69932db23ad58bd7393"
          },
          {
            "relationTo": "map",
            "value": "6718c69932db23ad58bd7398"
          },
          {
            "relationTo": "gallery",
            "value": "6718c69932db23ad58bd7394"
          },
          {
            "relationTo": "favourites",
            "value": "6718c69932db23ad58bd7395"
          },
          {
            "relationTo": "orbits",
            "value": "6718c69932db23ad58bd7388"
          },
          {
            "relationTo": "explorer",
            "value": "6718c69932db23ad58bd7389"
          },
          {
            "relationTo": "development",
            "value": "6718c69932db23ad58bd738a"
          },
          {
            "relationTo": "sharedOwnership",
            "value": "6718c69932db23ad58bd738b"
          },
          {
            "relationTo": "about",
            "value": "6718c69932db23ad58bd738c"
          },
          {
            "relationTo": "info1",
            "value": "6718c69932db23ad58bd738d"
          },
          {
            "relationTo": "unitAvailability",
            "value": "6718c69932db23ad58bd738e"
          },
          {
            "relationTo": "unitTypes",
            "value": "6718c69932db23ad58bd738f"
          },
          {
            "relationTo": "unitViews",
            "value": "6718c69932db23ad58bd7390"
          },
          {
            "relationTo": "unitDetails",
            "value": "6718c69932db23ad58bd7391"
          }
        ],
        "deployHook": "https://api.vercel.com/v1/integrations/deploy/prj_CKWm9EMM2cxCM1xmTDepkqqgISAi/a9Hr1Zfbch"
      },
      "options": "qrCodeOnly"
    },
    "emailSettings": {
      "ccAgentList": []
    }
  },
  "galleryData": {
    "relationTo": "gallery",
    "name": "Gallery - Trinity Park",
    "feature": "masonrygallery",
    "scroll": "horizontal",
    "enableCategories": true,
    "enableRounded": false,
    "style": "full",
    "spacing": "large",
    "categoryStyle": "type2",
    "categoryColor": "black",
    "images": [
      {
        "content": {
          "id": "6734bd05a0480a03f68a3559",
          "publicURL": "/payload/galleryMedia/1.webp",
          "filename": "1.webp",
          "mimeType": "image/webp",
          "filesize": 743486,
          "width": 5000,
          "height": 2812,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:51:49.561Z",
          "updatedAt": "2024-11-13T14:51:49.561Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/1.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "6718d5bfb5c2c7002689afe9"
      },
      {
        "content": {
          "id": "6734bd12a0480a03f68a3577",
          "publicURL": "/payload/galleryMedia/2.webp",
          "filename": "2.webp",
          "mimeType": "image/webp",
          "filesize": 834272,
          "width": 5000,
          "height": 2812,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:52:02.010Z",
          "updatedAt": "2024-11-13T14:52:02.010Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/2.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "6718d5ecb5c2c7002689b06d"
      },
      {
        "content": {
          "id": "6734bd1ca0480a03f68a3594",
          "publicURL": "/payload/galleryMedia/3.webp",
          "filename": "3.webp",
          "mimeType": "image/webp",
          "filesize": 902258,
          "width": 4981,
          "height": 2812,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:52:12.077Z",
          "updatedAt": "2024-11-13T14:52:12.077Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/3.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "6718d636b5c2c7002689b070"
      },
      {
        "content": {
          "id": "6734bd29a0480a03f68a35b2",
          "publicURL": "/payload/galleryMedia/4.webp",
          "filename": "4.webp",
          "mimeType": "image/webp",
          "filesize": 1091744,
          "width": 4503,
          "height": 5000,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:52:25.612Z",
          "updatedAt": "2024-11-13T14:52:25.612Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/4.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "6718fe6ef078980026fe3668"
      },
      {
        "content": {
          "id": "6734bd33a0480a03f68a35d2",
          "publicURL": "/payload/galleryMedia/5-3.webp",
          "filename": "5-3.webp",
          "mimeType": "image/webp",
          "filesize": 711694,
          "width": 5000,
          "height": 3126,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:52:35.862Z",
          "updatedAt": "2024-11-13T14:52:35.862Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/5-3.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "6718fea4f078980026fe3669"
      },
      {
        "content": {
          "id": "6734bd41a0480a03f68a35f1",
          "publicURL": "/payload/galleryMedia/6-1.webp",
          "filename": "6-1.webp",
          "mimeType": "image/webp",
          "filesize": 1016970,
          "width": 5000,
          "height": 3126,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:52:49.339Z",
          "updatedAt": "2024-11-13T14:52:49.339Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/6-1.webp",
          "thumbnailURL": null
        },
        "category": "Interiors",
        "id": "671a2903fda81600264df8b4"
      },
      {
        "content": {
          "id": "6734bd58a0480a03f68a3623",
          "publicURL": "/payload/galleryMedia/1-1.webp",
          "filename": "1-1.webp",
          "mimeType": "image/webp",
          "filesize": 632382,
          "width": 1920,
          "height": 1234,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:53:12.860Z",
          "updatedAt": "2024-11-13T14:53:12.860Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/1-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a292ffda81600264df8b5"
      },
      {
        "content": {
          "id": "6734bd67a0480a03f68a3669",
          "publicURL": "/payload/galleryMedia/2-1.webp",
          "filename": "2-1.webp",
          "mimeType": "image/webp",
          "filesize": 575594,
          "width": 1920,
          "height": 1982,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:53:27.403Z",
          "updatedAt": "2024-11-13T14:53:27.403Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/2-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a293afda81600264df8b6"
      },
      {
        "content": {
          "id": "6734bd70a0480a03f68a3687",
          "publicURL": "/payload/galleryMedia/3-1.webp",
          "filename": "3-1.webp",
          "mimeType": "image/webp",
          "filesize": 516474,
          "width": 1920,
          "height": 1404,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:53:36.300Z",
          "updatedAt": "2024-11-13T14:53:36.300Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/3-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a2942fda81600264df8b7"
      },
      {
        "content": {
          "id": "6734bd7ba0480a03f68a36a6",
          "publicURL": "/payload/galleryMedia/4-1.webp",
          "filename": "4-1.webp",
          "mimeType": "image/webp",
          "filesize": 587802,
          "width": 1920,
          "height": 1385,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:53:47.111Z",
          "updatedAt": "2024-11-13T14:53:47.111Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/4-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a294cfda81600264df8b8"
      },
      {
        "content": {
          "id": "6734bd84a0480a03f68a36c8",
          "publicURL": "/payload/galleryMedia/5-4.webp",
          "filename": "5-4.webp",
          "mimeType": "image/webp",
          "filesize": 615318,
          "width": 1920,
          "height": 1920,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:53:56.632Z",
          "updatedAt": "2024-11-13T14:53:56.632Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/5-4.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a2958fda81600264df8b9"
      },
      {
        "content": {
          "id": "6734bd8ea0480a03f68a36e4",
          "publicURL": "/payload/galleryMedia/6-2.webp",
          "filename": "6-2.webp",
          "mimeType": "image/webp",
          "filesize": 471598,
          "width": 1920,
          "height": 1423,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:54:06.201Z",
          "updatedAt": "2024-11-13T14:54:06.201Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/6-2.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a2962fda81600264df8ba"
      },
      {
        "content": {
          "id": "6734bd98a0480a03f68a3702",
          "publicURL": "/payload/galleryMedia/7-1.webp",
          "filename": "7-1.webp",
          "mimeType": "image/webp",
          "filesize": 590736,
          "width": 1920,
          "height": 2400,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:54:16.324Z",
          "updatedAt": "2024-11-13T14:54:16.324Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/7-1.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a296cfda81600264df8bb"
      },
      {
        "content": {
          "id": "6734bda6a0480a03f68a3734",
          "publicURL": "/payload/galleryMedia/8-2.webp",
          "filename": "8-2.webp",
          "mimeType": "image/webp",
          "filesize": 587650,
          "width": 1920,
          "height": 1440,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:54:30.767Z",
          "updatedAt": "2024-11-13T14:54:30.767Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/8-2.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a2977fda81600264df8bc"
      },
      {
        "content": {
          "id": "6734bdb3a0480a03f68a375e",
          "publicURL": "/payload/galleryMedia/9.webp",
          "filename": "9.webp",
          "mimeType": "image/webp",
          "filesize": 303766,
          "width": 1920,
          "height": 1615,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T14:54:43.328Z",
          "updatedAt": "2024-11-13T14:54:43.328Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/9.webp",
          "thumbnailURL": null
        },
        "category": "Exteriors",
        "id": "671a2981fda81600264df8bd"
      },
      {
        "content": {
          "id": "6734c50da0480a03f68a3dab",
          "publicURL": "/payload/galleryMedia/1-2.webp",
          "filename": "1-2.webp",
          "mimeType": "image/webp",
          "filesize": 194122,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:26:05.421Z",
          "updatedAt": "2024-11-13T15:26:05.421Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/1-2.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5011128c70026cf7531"
      },
      {
        "content": {
          "id": "6734c51ba0480a03f68a3de1",
          "publicURL": "/payload/galleryMedia/2-2.webp",
          "filename": "2-2.webp",
          "mimeType": "image/webp",
          "filesize": 221570,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:26:19.003Z",
          "updatedAt": "2024-11-13T15:26:19.003Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/2-2.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5111128c70026cf7532"
      },
      {
        "content": {
          "id": "6734c522a0480a03f68a3e09",
          "publicURL": "/payload/galleryMedia/3-6.webp",
          "filename": "3-6.webp",
          "mimeType": "image/webp",
          "filesize": 438778,
          "width": 1920,
          "height": 2694,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:26:26.288Z",
          "updatedAt": "2024-11-13T15:26:26.288Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/3-6.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c51c1128c70026cf7533"
      },
      {
        "content": {
          "id": "6734c52ea0480a03f68a3e3b",
          "publicURL": "/payload/galleryMedia/4-2.webp",
          "filename": "4-2.webp",
          "mimeType": "image/webp",
          "filesize": 406240,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:26:38.507Z",
          "updatedAt": "2024-11-13T15:26:38.507Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/4-2.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5271128c70026cf7534"
      },
      {
        "content": {
          "id": "6734c53ba0480a03f68a3e7c",
          "publicURL": "/payload/galleryMedia/5-5.webp",
          "filename": "5-5.webp",
          "mimeType": "image/webp",
          "filesize": 631738,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:26:51.252Z",
          "updatedAt": "2024-11-13T15:26:51.252Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/5-5.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5351128c70026cf7535"
      },
      {
        "content": {
          "id": "6734c546a0480a03f68a3eb3",
          "publicURL": "/payload/galleryMedia/6-3.webp",
          "filename": "6-3.webp",
          "mimeType": "image/webp",
          "filesize": 414386,
          "width": 1920,
          "height": 1280,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:27:02.310Z",
          "updatedAt": "2024-11-13T15:27:02.310Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/6-3.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5401128c70026cf7536"
      },
      {
        "content": {
          "id": "6734c552a0480a03f68a3ef9",
          "publicURL": "/payload/galleryMedia/8-3.webp",
          "filename": "8-3.webp",
          "mimeType": "image/webp",
          "filesize": 908644,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:27:14.794Z",
          "updatedAt": "2024-11-13T15:27:14.794Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/8-3.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c54c1128c70026cf7537"
      },
      {
        "content": {
          "id": "6734c55fa0480a03f68a3f32",
          "publicURL": "/payload/galleryMedia/7-2.webp",
          "filename": "7-2.webp",
          "mimeType": "image/webp",
          "filesize": 821290,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:27:27.617Z",
          "updatedAt": "2024-11-13T15:27:27.617Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/7-2.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5581128c70026cf7538"
      },
      {
        "content": {
          "id": "6734c56aa0480a03f68a3f67",
          "publicURL": "/payload/galleryMedia/9-1.webp",
          "filename": "9-1.webp",
          "mimeType": "image/webp",
          "filesize": 293594,
          "width": 1920,
          "height": 1280,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:27:38.333Z",
          "updatedAt": "2024-11-13T15:27:38.333Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/9-1.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5631128c70026cf7539"
      },
      {
        "content": {
          "id": "6734c574a0480a03f68a3f9d",
          "publicURL": "/payload/galleryMedia/10.webp",
          "filename": "10.webp",
          "mimeType": "image/webp",
          "filesize": 320648,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:27:48.052Z",
          "updatedAt": "2024-11-13T15:27:48.052Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/10.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c56e1128c70026cf753a"
      },
      {
        "content": {
          "id": "6734c581a0480a03f68a3fcf",
          "publicURL": "/payload/galleryMedia/11-2.webp",
          "filename": "11-2.webp",
          "mimeType": "image/webp",
          "filesize": 274654,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:01.340Z",
          "updatedAt": "2024-11-13T15:28:01.340Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/11-2.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5791128c70026cf753b"
      },
      {
        "content": {
          "id": "6734c589a0480a03f68a3ff0",
          "publicURL": "/payload/galleryMedia/12.webp",
          "filename": "12.webp",
          "mimeType": "image/webp",
          "filesize": 588110,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:09.225Z",
          "updatedAt": "2024-11-13T15:28:09.225Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/12.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5831128c70026cf753c"
      },
      {
        "content": {
          "id": "6734c592a0480a03f68a4012",
          "publicURL": "/payload/galleryMedia/13.webp",
          "filename": "13.webp",
          "mimeType": "image/webp",
          "filesize": 289254,
          "width": 1920,
          "height": 1280,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:18.495Z",
          "updatedAt": "2024-11-13T15:28:18.495Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/13.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c58a1128c70026cf753d"
      },
      {
        "content": {
          "id": "6734c59ca0480a03f68a4033",
          "publicURL": "/payload/galleryMedia/14.webp",
          "filename": "14.webp",
          "mimeType": "image/webp",
          "filesize": 303088,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:28.553Z",
          "updatedAt": "2024-11-13T15:28:28.553Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/14.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5951128c70026cf753e"
      },
      {
        "content": {
          "id": "6734c5a5a0480a03f68a4050",
          "publicURL": "/payload/galleryMedia/15.webp",
          "filename": "15.webp",
          "mimeType": "image/webp",
          "filesize": 152680,
          "width": 1920,
          "height": 1920,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:37.839Z",
          "updatedAt": "2024-11-13T15:28:37.839Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/15.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c59e1128c70026cf753f"
      },
      {
        "content": {
          "id": "6734c5aea0480a03f68a4072",
          "publicURL": "/payload/galleryMedia/16.webp",
          "filename": "16.webp",
          "mimeType": "image/webp",
          "filesize": 302122,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:46.677Z",
          "updatedAt": "2024-11-13T15:28:46.677Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/16.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5a81128c70026cf7540"
      },
      {
        "content": {
          "id": "6734c5b7a0480a03f68a4093",
          "publicURL": "/payload/galleryMedia/17.webp",
          "filename": "17.webp",
          "mimeType": "image/webp",
          "filesize": 418376,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:28:55.261Z",
          "updatedAt": "2024-11-13T15:28:55.261Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/17.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5b01128c70026cf7541"
      },
      {
        "content": {
          "id": "6734c5bfa0480a03f68a40b4",
          "publicURL": "/payload/galleryMedia/18.webp",
          "filename": "18.webp",
          "mimeType": "image/webp",
          "filesize": 69962,
          "width": 1920,
          "height": 2886,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:29:03.002Z",
          "updatedAt": "2024-11-13T15:29:03.002Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/18.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5b81128c70026cf7542"
      },
      {
        "content": {
          "id": "6734c5c7a0480a03f68a40d2",
          "publicURL": "/payload/galleryMedia/19.webp",
          "filename": "19.webp",
          "mimeType": "image/webp",
          "filesize": 141394,
          "width": 1920,
          "height": 2874,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:29:11.335Z",
          "updatedAt": "2024-11-13T15:29:11.335Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/19.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5c01128c70026cf7543"
      },
      {
        "content": {
          "id": "6734c5cfa0480a03f68a40f3",
          "publicURL": "/payload/galleryMedia/20.webp",
          "filename": "20.webp",
          "mimeType": "image/webp",
          "filesize": 199590,
          "width": 1920,
          "height": 2880,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-11-13T15:29:19.613Z",
          "updatedAt": "2024-11-13T15:29:19.613Z",
          "url": "https://luna.vmistudio.com/api/galleryMedia/file/20.webp",
          "thumbnailURL": null
        },
        "category": "Lifestyle",
        "id": "6734c5c81128c70026cf7544"
      }
    ]
  },
  "mapData": {
    "relationTo": "map",
    "name": "Map - Trinity Park",
    "feature": "googleMaps",
    "mapSettings": {
      "zoom": 16,
      "unitSystem": "METRIC",
      "withDirections": true
    },
    "mapPOIS": {
      "poiSettings": {
        "poiVisibility": "scaleActive",
        "poiIcon": {
          "id": "671a2c668168a18eb3452088",
          "publicURL": "/payload/organisationMedia/logo-3.png",
          "filename": "logo-3.png",
          "mimeType": "image/png",
          "filesize": 1618,
          "width": 100,
          "height": 100,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-24T11:15:50.415Z",
          "updatedAt": "2024-10-24T11:15:50.415Z",
          "url": "https://luna.vmistudio.com/api/organisationMedia/file/logo-3.png",
          "thumbnailURL": null
        }
      },
      "mainMarker": {
        "place": "Trinity",
        "description": "Location",
        "iconPath": {
          "id": "6734d60da0480a03f68a4ca4",
          "publicURL": "/payload/organisationMedia/logo-green.svg",
          "filename": "logo-green.svg",
          "mimeType": "image/svg+xml",
          "filesize": 483105,
          "width": 100,
          "height": 100,
          "createdAt": "2024-11-13T16:38:37.681Z",
          "updatedAt": "2024-11-13T16:38:37.681Z",
          "url": "https://luna.vmistudio.com/api/organisationMedia/file/logo-green.svg",
          "thumbnailURL": null
        },
        "coordinates": {
          "lat": 51.49072,
          "lng": 0.04701
        }
      },
      "pois": [
        {
          "place": "Woolwich Dockyard",
          "category": "Connections",
          "coordinates": {
            "lat": 51.49116,
            "lng": 0.05454
          },
          "id": "673212ae1128c70026cf3646"
        },
        {
          "place": "Woolwich Elizabeth Line",
          "category": "Connections",
          "coordinates": {
            "lat": 51.49207,
            "lng": 0.07054
          },
          "id": "673214501128c70026cf36b6"
        },
        {
          "place": "Woolwich Arsenal",
          "category": "Connections",
          "coordinates": {
            "lat": 51.49012,
            "lng": 0.06896
          },
          "id": "6732147c1128c70026cf36b7"
        },
        {
          "place": "London City Airport",
          "category": "Connections",
          "coordinates": {
            "lat": 51.50494,
            "lng": 0.04959
          },
          "id": "6732149d1128c70026cf36b8"
        },
        {
          "place": "Woolwich Pier",
          "category": "Connections",
          "coordinates": {
            "lat": 51.49533,
            "lng": 0.06242
          },
          "id": "673214da1128c70026cf36b9"
        },
        {
          "place": "Greenwich Pantry",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.49518,
            "lng": 0.04461
          },
          "id": "673216ec1128c70026cf3848"
        },
        {
          "place": "Kailash Momo",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.4891,
            "lng": 0.06748
          },
          "id": "673217211128c70026cf3849"
        },
        {
          "place": "Dial Arch Pub",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.49262,
            "lng": 0.07015
          },
          "id": "673217451128c70026cf384a"
        },
        {
          "place": "McDonald's",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.49292,
            "lng": 0.04635
          },
          "id": "673217881128c70026cf384b"
        },
        {
          "place": "SALT Woolwich",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.49244,
            "lng": 0.07166
          },
          "id": "6732179d1128c70026cf384c"
        },
        {
          "place": "Gail's Bakery",
          "category": "Food and Beverage",
          "coordinates": {
            "lat": 51.49221,
            "lng": 0.07072
          },
          "id": "673217c41128c70026cf384d"
        },
        {
          "place": "Mayron Park",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.48956,
            "lng": 0.04445
          },
          "id": "673218911128c70026cf38d1"
        },
        {
          "place": "Maryon Wilson Animal Park",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.48657,
            "lng": 0.04382
          },
          "id": "673218f71128c70026cf38d2"
        },
        {
          "place": "Woolwich Common",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.47959,
            "lng": 0.06017
          },
          "id": "673219471128c70026cf38d3"
        },
        {
          "place": "Waterfront Leisure Centre",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.49425,
            "lng": 0.06383
          },
          "id": "673219851128c70026cf38d4"
        },
        {
          "place": "The Reach Climbing Wall",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.49446,
            "lng": 0.04376
          },
          "id": "673219bc1128c70026cf38d5"
        },
        {
          "place": "The Yoga Space London",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.49478,
            "lng": 0.06676
          },
          "id": "673219e51128c70026cf38d6"
        },
        {
          "place": "Charlton Lido and Lifestyle Club",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.47543,
            "lng": 0.03963
          },
          "id": "67321a1f1128c70026cf38d7"
        },
        {
          "place": "PureGym",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.49142,
            "lng": 0.07294
          },
          "id": "67321a7a1128c70026cf38d8"
        },
        {
          "place": "Greenwich Peninsula Golf Range",
          "category": "Wellness and Leisure",
          "coordinates": {
            "lat": 51.49814,
            "lng": 0.00098
          },
          "id": "67321abf1128c70026cf38d9"
        },
        {
          "place": "London Sculpture Workshop",
          "category": "Arts and Culture",
          "coordinates": {
            "lat": 51.49527,
            "lng": 0.04267
          },
          "id": "67321b561128c70026cf38da"
        },
        {
          "place": "Woolwich Works",
          "category": "Arts and Culture",
          "coordinates": {
            "lat": 51.49448,
            "lng": 0.07052
          },
          "id": "67321b8e1128c70026cf38db"
        },
        {
          "place": "Punchdrunk",
          "category": "Arts and Culture",
          "coordinates": {
            "lat": 51.49379,
            "lng": 0.0715
          },
          "id": "67321bb31128c70026cf38dc"
        },
        {
          "place": "Magazine London",
          "category": "Arts and Culture",
          "coordinates": {
            "lat": 51.50094,
            "lng": -0.00053
          },
          "id": "67321bda1128c70026cf38dd"
        },
        {
          "place": "Busy Bees at Greenwich",
          "category": "Education",
          "coordinates": {
            "lat": 51.49397,
            "lng": 0.05095
          },
          "id": "67321c971128c70026cf38de"
        },
        {
          "place": "Bear Hugs Day Nursery Sandy Hill",
          "category": "Education",
          "coordinates": {
            "lat": 51.48375,
            "lng": 0.06998
          },
          "id": "67321cb31128c70026cf38df"
        },
        {
          "place": "Windrush Primary School",
          "category": "Education",
          "coordinates": {
            "lat": 51.49195,
            "lng": 0.04277
          },
          "id": "67321cdf1128c70026cf38e0"
        },
        {
          "place": "Thorntree Primary School",
          "category": "Education",
          "coordinates": {
            "lat": 51.48682,
            "lng": 0.04208
          },
          "id": "67321d061128c70026cf38e1"
        },
        {
          "place": "Mulgrave Primary School",
          "category": "Education",
          "coordinates": {
            "lat": 51.48871,
            "lng": 0.06142
          },
          "id": "67321d331128c70026cf38e2"
        },
        {
          "place": "Woodhill Primary School",
          "category": "Education",
          "coordinates": {
            "lat": 51.48942,
            "lng": 0.04817
          },
          "id": "67321d5b1128c70026cf38e3"
        },
        {
          "place": "St Mary Magdalene Primary School",
          "category": "Education",
          "coordinates": {
            "lat": 51.49166,
            "lng": 0.06207
          },
          "id": "67321d8c1128c70026cf38e4"
        },
        {
          "place": "Leigh Academy Blackheath",
          "category": "Education",
          "coordinates": {
            "lat": 51.47593,
            "lng": 0.02817
          },
          "id": "67321df21128c70026cf38e5"
        },
        {
          "place": "Townley Grammar School",
          "category": "Education",
          "coordinates": {
            "lat": 51.45068,
            "lng": 0.14144
          },
          "id": "67321e201128c70026cf38e6"
        },
        {
          "place": "Blackheath High School ",
          "category": "Education",
          "coordinates": {
            "lat": 51.47799,
            "lng": 0.01681
          },
          "id": "67321e4a1128c70026cf38e7"
        },
        {
          "place": "The Pointer School",
          "category": "Education",
          "coordinates": {
            "lat": 51.47493,
            "lng": 0.01823
          },
          "id": "67321e8e1128c70026cf38e8"
        },
        {
          "place": "University of Greenwich",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.4831,
            "lng": -0.00589
          },
          "id": "67321ed21128c70026cf38e9"
        },
        {
          "place": "University of East London",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.50772,
            "lng": 0.06554
          },
          "id": "67321f1f1128c70026cf38ea"
        },
        {
          "place": "University of arts London",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.54178,
            "lng": -0.01266
          },
          "id": "67321f4f1128c70026cf38eb"
        },
        {
          "place": "The Woolwich College",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.49201,
            "lng": 0.0644
          },
          "id": "67321fae1128c70026cf38ec"
        },
        {
          "place": "UCL School of Management",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.50617,
            "lng": -0.01152
          },
          "id": "67321fd81128c70026cf38ed"
        },
        {
          "place": "Goldsmiths University",
          "category": "Further Education",
          "coordinates": {
            "lat": 51.4757,
            "lng": -0.03964
          },
          "id": "6732200a1128c70026cf3adc"
        },
        {
          "place": "Mini Market, Post Office Maryon Road",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.48777,
            "lng": 0.04996
          },
          "id": "673220ab1128c70026cf3f5a"
        },
        {
          "place": "Sainsbury's",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.49112,
            "lng": 0.06401
          },
          "id": "673220dc1128c70026cf3f5b"
        },
        {
          "place": "Lidl",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.49251,
            "lng": 0.06627
          },
          "id": "6732210f1128c70026cf3f5c"
        },
        {
          "place": "Tesco Express",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.49266,
            "lng": 0.07186
          },
          "id": "673221361128c70026cf3f5d"
        },
        {
          "place": "Queen Elizabeth Hospital",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.47791,
            "lng": 0.05012
          },
          "id": "673221de1128c70026cf3feb"
        },
        {
          "place": "IKEA",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.48992,
            "lng": 0.01664
          },
          "id": "673222021128c70026cf3fec"
        },
        {
          "place": "NS Warwick Pharmacy",
          "category": "Amenities",
          "coordinates": {
            "lat": 51.49257,
            "lng": 0.05636
          },
          "id": "673222261128c70026cf3fed"
        },
        {
          "place": "The O2",
          "category": "Destinations",
          "coordinates": {
            "lat": 51.50323,
            "lng": 0.00389
          },
          "id": "673222aa1128c70026cf40fe"
        },
        {
          "place": "Canary Wharf",
          "category": "Destinations",
          "coordinates": {
            "lat": 51.50547,
            "lng": -0.02309
          },
          "id": "673222d11128c70026cf40ff"
        },
        {
          "place": "The Thames Barrier",
          "category": "Destinations",
          "coordinates": {
            "lat": 51.49462,
            "lng": 0.03826
          },
          "id": "673223011128c70026cf4100"
        },
        {
          "place": "Royal Albert Dock",
          "category": "Destinations",
          "coordinates": {
            "lat": 51.50792,
            "lng": 0.05323
          },
          "id": "6732232d1128c70026cf4101"
        },
        {
          "place": "Greenwich Market",
          "category": "Destinations",
          "coordinates": {
            "lat": 51.48169,
            "lng": -0.00874
          },
          "id": "673223521128c70026cf4102"
        }
      ]
    },
    "mapStyling": {
      "styleKey": "dark",
      "style": [],
      "customColors": {
        "landscapeColor": "#2b505a",
        "waterColor": "#b1b1b1",
        "parksColor": "#c9c9c9",
        "arterialColor": "#ffffff",
        "localColor": "#989898",
        "labelsColor": "#fff8c9"
      }
    },
    "categories": [
      "Connections",
      "Food and Beverage",
      "Arts and Culture",
      "Education",
      "Further Education",
      "Amenities",
      "Destinations",
      "Wellness and Leisure"
    ]
  },
  "residencesData": {
    "relationTo": "residences",
    "feature": "residencesType2",
    "categories": [
      "Floorplan",
      "Specifications"
    ],
    "name": "Residences - Trinity Park"
  },
  "orbitData": {
    "relationTo": "orbits",
    "name": "Orbits - Trinity Park",
    "feature": "orbit3d",
    "cameraPoints": [],
    "touchPoints": []
  },
  "splashData": {
    "relationTo": "splash",
    "name": "Splash - Trinity Park",
    "heroCopy": "Residences",
    "heroCopyFont": "primaryFont",
    "heroCopyColour": "primary",
    "heroCopyStyle": "normal",
    "buttonBgColour": "accent",
    "buttonWidth": 10,
    "buttonBgLink": "residences",
    "logo": "lightColourLogo",
    "logoWidth": 51.25,
    "splashBg": "image/video",
    "splashBgMediaOpacity": 0.75,
    "splashBgMedia": {
      "id": "673c8e4ba0480a03f68b0129",
      "publicURL": "/payload/splashMedia/TRINITY_PARK.mp4",
      "filename": "TRINITY_PARK.mp4",
      "mimeType": "video/mp4",
      "filesize": 79807660,
      "createdAt": "2024-11-19T13:10:35.352Z",
      "updatedAt": "2024-11-19T13:10:35.352Z",
      "url": "https://luna.vmistudio.com/api/splashMedia/file/TRINITY_PARK.mp4",
      "thumbnailURL": null
    }
  },
  "availabilityData": {
    "relationTo": "unitAvailability",
    "name": "Unit Availability - Trinity Park",
    "csv": null,
    "data": [
      {
        "unitName": "101",
        "price": 2000000,
        "floor": 0,
        "unitType": "2L",
        "aspect": "SW",
        "viewID": "A-B-3m",
        "status": "Unreleased",
        "id": "6a9e0bd056cb49002096ae20"
      },
      {
        "unitName": "102",
        "price": 12000000,
        "floor": 0,
        "unitType": "1F",
        "aspect": "W",
        "viewID": "C-D-12m",
        "status": "Unreleased",
        "id": "6a9e0bd056cb49002096ae21"
      },
      {
        "unitName": "103",
        "price": 5000000,
        "floor": 0,
        "unitType": "2L",
        "aspect": "W",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae22"
      },
      {
        "unitName": "104",
        "price": 2000000,
        "floor": 0,
        "unitType": "1F",
        "aspect": "W",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae23"
      },
      {
        "unitName": "105",
        "price": 12000000,
        "floor": 0,
        "unitType": "2L",
        "aspect": "W",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae24"
      },
      {
        "unitName": "106",
        "price": 5000000,
        "floor": 0,
        "unitType": "1F",
        "aspect": "E",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae25"
      },
      {
        "unitName": "107",
        "price": 2000000,
        "floor": 0,
        "unitType": "2L",
        "aspect": "E",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae26"
      },
      {
        "unitName": "108",
        "price": 12000000,
        "floor": 0,
        "unitType": "1F",
        "aspect": "E",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae27"
      },
      {
        "unitName": "109",
        "price": 5000000,
        "floor": 0,
        "unitType": "2L",
        "aspect": "E",
        "viewID": "A-B-3m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae28"
      },
      {
        "unitName": "110",
        "price": 2000000,
        "floor": 0,
        "unitType": "1F",
        "aspect": "SE",
        "viewID": "C-D-12m",
        "status": "Available",
        "id": "6a9e0bd056cb49002096ae29"
      }
    ]
  },
  "typeData": {
    "relationTo": "unitTypes",
    "name": "Unit Types - Trinity Park",
    "unitTypes": [
      {
        "name": "S54",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b23ac89aec3d0bb23f",
          "publicURL": "/payload/floorPlanMedia/S54.svg",
          "filename": "S54.svg",
          "mimeType": "image/svg+xml",
          "filesize": 385328,
          "width": 832,
          "height": 560,
          "createdAt": "2024-12-11T13:25:06.413Z",
          "updatedAt": "2024-12-11T13:25:06.413Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S54.svg",
          "thumbnailURL": null
        },
        "id": "673336f91128c70026cf4bbb"
      },
      {
        "name": "S54-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b13ac89aec3d0bb23b",
          "publicURL": "/payload/floorPlanMedia/S54-info.svg",
          "filename": "S54-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 471140,
          "width": 900,
          "height": 799,
          "createdAt": "2024-12-11T13:25:05.998Z",
          "updatedAt": "2024-12-11T13:25:05.998Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S54-info.svg",
          "thumbnailURL": null
        },
        "id": "6733370f1128c70026cf4bbc"
      },
      {
        "name": "S53",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b13ac89aec3d0bb237",
          "publicURL": "/payload/floorPlanMedia/S53.svg",
          "filename": "S53.svg",
          "mimeType": "image/svg+xml",
          "filesize": 385328,
          "width": 832,
          "height": 560,
          "createdAt": "2024-12-11T13:25:05.553Z",
          "updatedAt": "2024-12-11T13:25:05.553Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S53.svg",
          "thumbnailURL": null
        },
        "id": "673337551128c70026cf4da1"
      },
      {
        "name": "S53-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b13ac89aec3d0bb233",
          "publicURL": "/payload/floorPlanMedia/S53-info.svg",
          "filename": "S53-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 464202,
          "width": 900,
          "height": 799,
          "createdAt": "2024-12-11T13:25:05.182Z",
          "updatedAt": "2024-12-11T13:25:05.182Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S53-info.svg",
          "thumbnailURL": null
        },
        "id": "6733376b1128c70026cf4da2"
      },
      {
        "name": "S45",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b03ac89aec3d0bb22f",
          "publicURL": "/payload/floorPlanMedia/S45.svg",
          "filename": "S45.svg",
          "mimeType": "image/svg+xml",
          "filesize": 404469,
          "width": 878,
          "height": 560,
          "createdAt": "2024-12-11T13:25:04.752Z",
          "updatedAt": "2024-12-11T13:25:04.752Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S45.svg",
          "thumbnailURL": null
        },
        "id": "673337851128c70026cf4da3"
      },
      {
        "name": "S45-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992b03ac89aec3d0bb22b",
          "publicURL": "/payload/floorPlanMedia/S45-info.svg",
          "filename": "S45-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 490535,
          "width": 900,
          "height": 799,
          "createdAt": "2024-12-11T13:25:04.360Z",
          "updatedAt": "2024-12-11T13:25:04.360Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/S45-info.svg",
          "thumbnailURL": null
        },
        "id": "6733379c1128c70026cf4da4"
      },
      {
        "name": "S44",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992af3ac89aec3d0bb227",
          "publicURL": "/payload/floorPlanMedia/43612.svg",
          "filename": "43612.svg",
          "mimeType": "image/svg+xml",
          "filesize": 404435,
          "width": 878,
          "height": 560,
          "createdAt": "2024-12-11T13:25:03.931Z",
          "updatedAt": "2024-12-13T14:28:53.308Z",
          "thumbnailURL": null,
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43612.svg"
        },
        "id": "673337b71128c70026cf4da5"
      },
      {
        "name": "S44-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992af3ac89aec3d0bb223",
          "publicURL": "/payload/floorPlanMedia/43612-info.svg",
          "filename": "43612-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 490501,
          "width": 900,
          "height": 799,
          "createdAt": "2024-12-11T13:25:03.608Z",
          "updatedAt": "2024-12-13T14:25:11.079Z",
          "thumbnailURL": null,
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43612-info.svg"
        },
        "id": "673337e21128c70026cf4da6"
      },
      {
        "name": "43622",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992af3ac89aec3d0bb21f",
          "publicURL": "/payload/floorPlanMedia/43622.svg",
          "filename": "43622.svg",
          "mimeType": "image/svg+xml",
          "filesize": 385365,
          "width": 886,
          "height": 600,
          "createdAt": "2024-12-11T13:25:03.055Z",
          "updatedAt": "2024-12-11T13:25:03.055Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43622.svg",
          "thumbnailURL": null
        },
        "id": "673337fb1128c70026cf4da7"
      },
      {
        "name": "43622-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ae3ac89aec3d0bb21b",
          "publicURL": "/payload/floorPlanMedia/43622-info.svg",
          "filename": "43622-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 465322,
          "width": 900,
          "height": 821,
          "createdAt": "2024-12-11T13:25:02.687Z",
          "updatedAt": "2024-12-11T13:25:02.687Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43622-info.svg",
          "thumbnailURL": null
        },
        "id": "6733380e1128c70026cf4da8"
      },
      {
        "name": "43606",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ae3ac89aec3d0bb217",
          "publicURL": "/payload/floorPlanMedia/43606.svg",
          "filename": "43606.svg",
          "mimeType": "image/svg+xml",
          "filesize": 387388,
          "width": 879,
          "height": 600,
          "createdAt": "2024-12-11T13:25:02.255Z",
          "updatedAt": "2024-12-11T13:25:02.255Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43606.svg",
          "thumbnailURL": null
        },
        "id": "673338211128c70026cf4da9"
      },
      {
        "name": "43606-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ad3ac89aec3d0bb213",
          "publicURL": "/payload/floorPlanMedia/43606-info.svg",
          "filename": "43606-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 480416,
          "width": 900,
          "height": 821,
          "createdAt": "2024-12-11T13:25:01.864Z",
          "updatedAt": "2024-12-11T13:25:01.864Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43606-info.svg",
          "thumbnailURL": null
        },
        "id": "673338331128c70026cf4daa"
      },
      {
        "name": "43605",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ad3ac89aec3d0bb20f",
          "publicURL": "/payload/floorPlanMedia/43605.svg",
          "filename": "43605.svg",
          "mimeType": "image/svg+xml",
          "filesize": 389727,
          "width": 811,
          "height": 600,
          "createdAt": "2024-12-11T13:25:01.391Z",
          "updatedAt": "2024-12-11T13:25:01.391Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43605.svg",
          "thumbnailURL": null
        },
        "id": "673338541128c70026cf4dab"
      },
      {
        "name": "43605-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ac3ac89aec3d0bb20b",
          "publicURL": "/payload/floorPlanMedia/43605-info.svg",
          "filename": "43605-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 497431,
          "width": 900,
          "height": 821,
          "createdAt": "2024-12-11T13:25:00.938Z",
          "updatedAt": "2024-12-11T13:25:00.938Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43605-info.svg",
          "thumbnailURL": null
        },
        "id": "673338621128c70026cf4dac"
      },
      {
        "name": "43602",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ac3ac89aec3d0bb207",
          "publicURL": "/payload/floorPlanMedia/43602.svg",
          "filename": "43602.svg",
          "mimeType": "image/svg+xml",
          "filesize": 480416,
          "width": 900,
          "height": 821,
          "createdAt": "2024-12-11T13:25:00.571Z",
          "updatedAt": "2024-12-11T13:25:00.571Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43602.svg",
          "thumbnailURL": null
        },
        "id": "673338771128c70026cf4dad"
      },
      {
        "name": "43602-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ac3ac89aec3d0bb203",
          "publicURL": "/payload/floorPlanMedia/43602-info.svg",
          "filename": "43602-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 480416,
          "width": 900,
          "height": 821,
          "createdAt": "2024-12-11T13:25:00.164Z",
          "updatedAt": "2024-12-11T13:25:00.164Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/43602-info.svg",
          "thumbnailURL": null
        },
        "id": "6733388c1128c70026cf4dae"
      },
      {
        "name": "33531",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ab3ac89aec3d0bb1ff",
          "publicURL": "/payload/floorPlanMedia/33531.svg",
          "filename": "33531.svg",
          "mimeType": "image/svg+xml",
          "filesize": 429812,
          "width": 890,
          "height": 700,
          "createdAt": "2024-12-11T13:24:59.615Z",
          "updatedAt": "2024-12-11T13:24:59.615Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/33531.svg",
          "thumbnailURL": null
        },
        "id": "673338aa1128c70026cf4daf"
      },
      {
        "name": "33531-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992ab3ac89aec3d0bb1fb",
          "publicURL": "/payload/floorPlanMedia/33531-info.svg",
          "filename": "33531-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 525601,
          "width": 900,
          "height": 870,
          "createdAt": "2024-12-11T13:24:59.241Z",
          "updatedAt": "2024-12-11T13:24:59.241Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/33531-info.svg",
          "thumbnailURL": null
        },
        "id": "673338dd1128c70026cf4db0"
      },
      {
        "name": "23515",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992aa3ac89aec3d0bb1f7",
          "publicURL": "/payload/floorPlanMedia/23515.svg",
          "filename": "23515.svg",
          "mimeType": "image/svg+xml",
          "filesize": 292708,
          "width": 504,
          "height": 700,
          "createdAt": "2024-12-11T13:24:58.804Z",
          "updatedAt": "2024-12-11T13:24:58.804Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23515.svg",
          "thumbnailURL": null
        },
        "id": "673338f71128c70026cf4db1"
      },
      {
        "name": "23515-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992aa3ac89aec3d0bb1f3",
          "publicURL": "/payload/floorPlanMedia/23515-info.svg",
          "filename": "23515-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 374600,
          "width": 900,
          "height": 859,
          "createdAt": "2024-12-11T13:24:58.476Z",
          "updatedAt": "2024-12-11T13:24:58.476Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23515-info.svg",
          "thumbnailURL": null
        },
        "id": "673339071128c70026cf4db2"
      },
      {
        "name": "23514",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992aa3ac89aec3d0bb1ef",
          "publicURL": "/payload/floorPlanMedia/23514.svg",
          "filename": "23514.svg",
          "mimeType": "image/svg+xml",
          "filesize": 392309,
          "width": 516,
          "height": 700,
          "createdAt": "2024-12-11T13:24:58.049Z",
          "updatedAt": "2024-12-11T13:24:58.049Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23514.svg",
          "thumbnailURL": null
        },
        "id": "673339191128c70026cf4db3"
      },
      {
        "name": "23514-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a93ac89aec3d0bb1eb",
          "publicURL": "/payload/floorPlanMedia/23514-info.svg",
          "filename": "23514-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 472650,
          "width": 900,
          "height": 863,
          "createdAt": "2024-12-11T13:24:57.690Z",
          "updatedAt": "2024-12-11T13:24:57.690Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23514-info.svg",
          "thumbnailURL": null
        },
        "id": "673339301128c70026cf4db4"
      },
      {
        "name": "23513",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "6733691ba0480a03f689fe4f",
          "publicURL": "/payload/floorPlanMedia/23513.svg",
          "filename": "23513.svg",
          "mimeType": "image/svg+xml",
          "filesize": 355664,
          "width": 900,
          "height": 700,
          "createdAt": "2024-11-12T14:41:31.656Z",
          "updatedAt": "2024-11-12T14:41:31.656Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23513.svg",
          "thumbnailURL": null
        },
        "id": "673339461128c70026cf4db5"
      },
      {
        "name": "23513-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "67336925a0480a03f689fe71",
          "publicURL": "/payload/floorPlanMedia/23513-info.svg",
          "filename": "23513-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 432407,
          "width": 900,
          "height": 900,
          "createdAt": "2024-11-12T14:41:41.416Z",
          "updatedAt": "2024-11-12T14:41:41.416Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23513-info.svg",
          "thumbnailURL": null
        },
        "id": "673339551128c70026cf4db6"
      },
      {
        "name": "23512",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a93ac89aec3d0bb1e7",
          "publicURL": "/payload/floorPlanMedia/23512.svg",
          "filename": "23512.svg",
          "mimeType": "image/svg+xml",
          "filesize": 490859,
          "width": 786,
          "height": 700,
          "createdAt": "2024-12-11T13:24:57.198Z",
          "updatedAt": "2024-12-11T13:24:57.198Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23512.svg",
          "thumbnailURL": null
        },
        "id": "6733396b1128c70026cf4db7"
      },
      {
        "name": "23512-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a83ac89aec3d0bb1e3",
          "publicURL": "/payload/floorPlanMedia/23512-info.svg",
          "filename": "23512-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 567694,
          "width": 900,
          "height": 859,
          "createdAt": "2024-12-11T13:24:56.627Z",
          "updatedAt": "2024-12-11T13:24:56.627Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23512-info.svg",
          "thumbnailURL": null
        },
        "id": "673339801128c70026cf4db8"
      },
      {
        "name": "23402",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a83ac89aec3d0bb1df",
          "publicURL": "/payload/floorPlanMedia/23402.svg",
          "filename": "23402.svg",
          "mimeType": "image/svg+xml",
          "filesize": 391695,
          "width": 481,
          "height": 700,
          "createdAt": "2024-12-11T13:24:56.184Z",
          "updatedAt": "2024-12-11T13:24:56.184Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23402.svg",
          "thumbnailURL": null
        },
        "id": "673339991128c70026cf4db9"
      },
      {
        "name": "23402-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a73ac89aec3d0bb1db",
          "publicURL": "/payload/floorPlanMedia/23402-info.svg",
          "filename": "23402-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 462693,
          "width": 900,
          "height": 859,
          "createdAt": "2024-12-11T13:24:55.771Z",
          "updatedAt": "2024-12-11T13:24:55.771Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23402-info.svg",
          "thumbnailURL": null
        },
        "id": "673339b01128c70026cf4dba"
      },
      {
        "name": "23401",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a73ac89aec3d0bb1d7",
          "publicURL": "/payload/floorPlanMedia/23401.svg",
          "filename": "23401.svg",
          "mimeType": "image/svg+xml",
          "filesize": 298516,
          "width": 359,
          "height": 700,
          "createdAt": "2024-12-11T13:24:55.280Z",
          "updatedAt": "2024-12-11T13:24:55.280Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23401.svg",
          "thumbnailURL": null
        },
        "id": "673339c81128c70026cf4dbb"
      },
      {
        "name": "23401-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "675992a63ac89aec3d0bb1d3",
          "publicURL": "/payload/floorPlanMedia/23401-info.svg",
          "filename": "23401-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 371997,
          "width": 900,
          "height": 859,
          "createdAt": "2024-12-11T13:24:54.916Z",
          "updatedAt": "2024-12-11T13:24:54.916Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/23401-info.svg",
          "thumbnailURL": null
        },
        "id": "673339d61128c70026cf4dbc"
      },
      {
        "name": "21213",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "674f24649acd836c8f7bdbb3",
          "publicURL": "/payload/floorPlanMedia/21213.svg",
          "filename": "21213.svg",
          "mimeType": "image/svg+xml",
          "filesize": 261800,
          "width": 670,
          "height": 700,
          "createdAt": "2024-12-03T15:31:48.559Z",
          "updatedAt": "2024-12-03T15:31:48.559Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/21213.svg",
          "thumbnailURL": null
        },
        "id": "673339e71128c70026cf4dbd"
      },
      {
        "name": "21213-info",
        "beds": 1,
        "baths": 1,
        "floorplan": {
          "id": "674f24649acd836c8f7bdbaf",
          "publicURL": "/payload/floorPlanMedia/21213-info.svg",
          "filename": "21213-info.svg",
          "mimeType": "image/svg+xml",
          "filesize": 319188,
          "width": 900,
          "height": 849,
          "createdAt": "2024-12-03T15:31:48.052Z",
          "updatedAt": "2024-12-03T15:31:48.052Z",
          "url": "https://luna.vmistudio.com/api/floorPlanMedia/file/21213-info.svg",
          "thumbnailURL": null
        },
        "id": "673339f81128c70026cf4dbe"
      }
    ]
  },
  "viewsData": {
    "relationTo": "unitViews",
    "name": "Unit Views - Trinity Park",
    "viewMedia": [
      {
        "image": {
          "id": "67191095535ac37b8d534172",
          "publicURL": "/payload/viewMedia/C-12m.webp",
          "filename": "C-12m.webp",
          "mimeType": "image/webp",
          "filesize": 869212,
          "width": 5000,
          "height": 1990,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:04:53.249Z",
          "updatedAt": "2024-10-23T15:04:53.249Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/C-12m.webp",
          "thumbnailURL": null
        },
        "id": "6719108efed869002d77267c"
      },
      {
        "image": {
          "id": "6719109e535ac37b8d534193",
          "publicURL": "/payload/viewMedia/D-12m.webp",
          "filename": "D-12m.webp",
          "mimeType": "image/webp",
          "filesize": 1940010,
          "width": 6778,
          "height": 2357,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:02.855Z",
          "updatedAt": "2024-10-23T15:05:02.855Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/D-12m.webp",
          "thumbnailURL": null
        },
        "id": "67191096fed869002d77267d"
      },
      {
        "image": {
          "id": "671910b7535ac37b8d5341c0",
          "publicURL": "/payload/viewMedia/A-3m.webp",
          "filename": "A-3m.webp",
          "mimeType": "image/webp",
          "filesize": 869212,
          "width": 5000,
          "height": 1990,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:27.577Z",
          "updatedAt": "2024-10-23T15:05:27.577Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/A-3m.webp",
          "thumbnailURL": null
        },
        "id": "671910b1fed869002d77267e"
      },
      {
        "image": {
          "id": "671910c1535ac37b8d5341e2",
          "publicURL": "/payload/viewMedia/B-3m.webp",
          "filename": "B-3m.webp",
          "mimeType": "image/webp",
          "filesize": 1940010,
          "width": 6778,
          "height": 2357,
          "focalX": 50,
          "focalY": 50,
          "createdAt": "2024-10-23T15:05:37.338Z",
          "updatedAt": "2024-10-23T15:05:37.338Z",
          "url": "https://luna.vmistudio.com/api/viewMedia/file/B-3m.webp",
          "thumbnailURL": null
        },
        "id": "671910b9fed869002d77267f"
      }
    ]
  },
  "detailsData": {
    "relationTo": "unitDetails",
    "name": "Unit Details - Trinity Park"
  },
  "navRoutes": [
    {
      "path": "info1",
      "feature": "info1",
      "layout": "sidebar",
      "label": "Intro",
      "include": "true"
    },
    {
      "path": "residences",
      "feature": "residencesType2",
      "layout": "sidebar",
      "label": "Residences",
      "include": "true"
    },
    {
      "path": "map",
      "feature": "googleMaps",
      "layout": "sidebar",
      "label": "Map",
      "include": "true"
    },
    {
      "path": "gallery",
      "feature": "masonrygallery",
      "layout": "sidebar",
      "label": "Gallery",
      "include": "true"
    },
    {
      "path": "favourites",
      "feature": "favourites",
      "layout": "sidebar",
      "label": "Favourites",
      "include": "true"
    },
    {
      "path": "explorer",
      "feature": null,
      "layout": "sidebar",
      "label": "Explorer",
      "include": "false"
    },
    {
      "path": "development",
      "feature": "development",
      "layout": "sidebar",
      "label": "Development",
      "include": "false"
    },
    {
      "path": "orbits",
      "feature": "orbit3d",
      "layout": "sidebar",
      "label": "Orbit",
      "include": "false"
    },
    {
      "path": "sharedOwnership",
      "feature": "sharedOwnership",
      "layout": "sidebar",
      "label": "Shared Ownership",
      "include": "false"
    },
    {
      "path": "about",
      "feature": "about",
      "layout": "sidebar",
      "label": "About Page",
      "include": "false"
    }
  ],
  "allRoutes": [
    {
      "path": "/",
      "feature": "sidebar-splash",
      "layout": "sidebar",
      "include": "true"
    },
    {
      "path": "info1",
      "feature": "info1",
      "layout": "sidebar",
      "label": "Intro",
      "include": "true"
    },
    {
      "path": "residences",
      "feature": "residencesType2",
      "layout": "sidebar",
      "label": "Residences",
      "include": "true"
    },
    {
      "path": "map",
      "feature": "googleMaps",
      "layout": "sidebar",
      "label": "Map",
      "include": "true"
    },
    {
      "path": "gallery",
      "feature": "masonrygallery",
      "layout": "sidebar",
      "label": "Gallery",
      "include": "true"
    },
    {
      "path": "favourites",
      "feature": "favourites",
      "layout": "sidebar",
      "label": "Favourites",
      "include": "true"
    },
    {
      "path": "explorer",
      "feature": null,
      "layout": "sidebar",
      "label": "Explorer",
      "include": "false"
    },
    {
      "path": "development",
      "feature": "development",
      "layout": "sidebar",
      "label": "Development",
      "include": "false"
    },
    {
      "path": "orbits",
      "feature": "orbit3d",
      "layout": "sidebar",
      "label": "Orbit",
      "include": "false"
    },
    {
      "path": "sharedOwnership",
      "feature": "sharedOwnership",
      "layout": "sidebar",
      "label": "Shared Ownership",
      "include": "false"
    },
    {
      "path": "about",
      "feature": "about",
      "layout": "sidebar",
      "label": "About Page",
      "include": "false"
    }
  ]
};
  